import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {AlgemeneTip, AlgemeneTipDto} from './algemene-tip';
import { HttpClient, HttpParams } from '@angular/common/http';
import {map} from 'rxjs/operators';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AlgemeneTipService {
  private http = inject(HttpClient);

  getAlgemeneTips$(categorieId: string, taakId: string): Observable<Array<AlgemeneTip>> {
    const params = new HttpParams()
      .set('categorieId', categorieId)
      .set('taakId', taakId);
    return this.http.get<Array<AlgemeneTipDto>>(`${environment.apiUrl}/algemenetips`, {params})
      .pipe(map(dtos => dtos.map(dto => AlgemeneTip.deserialize(dto))));
  }

  postAlgemeneTip$(dienstId: string, categorieId: string, taakId: string, content: string): Observable<AlgemeneTip> {
    return this.http.post<AlgemeneTipDto>(`${environment.apiUrl}/algemenetips`, {dienstId, categorieId, taakId, content})
      .pipe(map(dto => AlgemeneTip.deserialize(dto)));
  }

  putAlgemeneTip$(id: string, content: string): Observable<AlgemeneTip> {
    return this.http.put<AlgemeneTipDto>(`${environment.apiUrl}/algemenetips/${id}`, {content})
      .pipe(map(dto => AlgemeneTip.deserialize(dto)));
  }

  deleteAlgemeneTip$(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/algemenetips/${id}`);
  }
}
